// The subpath the site is served from, e.g. /komodo. Kept in sync with the
// basePath in next.config.mjs, which exports it as NEXT_PUBLIC_BASE_PATH.
//
// next/link and Next's own asset URLs get the prefix automatically. Anything
// written by hand does not: <link> tags in <head>, <source> elements inside
// <video>, direct links to files in public/. Those go through withBasePath.
export const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH || '';

/**
 * Prefixes a root-relative path with the basePath.
 *
 * Only for assets and markup Next does not rewrite itself. Do not use it on
 * next/link hrefs - Next already prefixes those, and doing it twice yields
 * /komodo/komodo/...
 *
 * @param {string} path root-relative path, e.g. /favicon.ico
 * @returns {string} the same path behind the basePath
 */
export const withBasePath = (path) => `${BASE_PATH}${path}`;
